import React from 'react';
import styled from 'styled-components';
import {NavLink, Routes, Route} from 'react-router-dom';
import Inicio from './componentes/Inicio';
import Blog from './componentes/Blog';
import Tienda from './componentes/Tienda';
import Podcast from './componentes/Podcast';
import Error404 from './componentes/Error404';
import Carrito from './componentes/Carrito';
import {Provider} from 'react-redux';
import {createStore} from 'redux';
import reducer from './reducers/tiendaReducer';
//import LogoSrc from './img/butterfly.png';
import LogoSrc from './img/LOGOAZULDORADO.png';
const App = () => {

    const store = createStore(reducer);
    
    return (
        <Provider store={store}>
            <Contenedor>
                <HEADER> 
                    <Logo src={LogoSrc} />
                    {/*<h1>TANCÚ</h1>
                    <Logo2 src={LogoSrc} />*/}
                    <H3>
                        <h3>Tanatología y Cuidados Paliativos</h3>    
                    </H3> 
                    
                </HEADER>
                <HEADER2>
                     <p>Tanatología y Cuidados Paliativos</p> 
                </HEADER2>
                
                <Menu>
                    <NavLink to="/">Inicio</NavLink>
                    <NavLink to="/blog">Diagnostico</NavLink>
                    <NavLink to="/Podcast">Podcast</NavLink>
                    {/* <NavLink to="/tienda">Servicios</NavLink> */}
                </Menu>
                <main>
                    <Routes>
                        <Route path="*" element={<Error404 />}/>
                        <Route path="/" element={<Inicio />}/>
                        <Route path="/blog" element={<Blog />}/>
                        <Route path="/Podcast" element={<Podcast />}/>
                        <Route path="/tienda" element={<Tienda />} />
                    </Routes>
                </main>
                {/* <aside>
                    <Carrito />
                </aside> */}
            </Contenedor>
        </Provider>
        
    );
}


const Contenedor = styled.div`
    width: 100%;
    max-width: 1000px;
    padding: 4px;
    // display: grid;
    // gap: 20px;
    // grid-template-columns: 2fr 1fr;
    // grid-template-columns: 3fr;
    background: #00fff;
    margin: 40px 0;
    // border-radius: 10px;
    // box-shadow: 0px 0px 5px rgba(129, 129, 129, 0.1);
    
    @media (max-width: 420px) { 
        width: 100%;
        // max-width: 520px;
        font-size: 20px;
        color: #092c4c;
        background: #00fff;
        // padding: 0rem 10rem 0rem 0rem
      }
`;
 
const Menu = styled.nav`
    width: 100%;
    text-align: center;
    background: #092c4c;
    // grid-column: span 2;
    border-radius: 3px;
    margin: 2rem;
    a {
        color: #fff;
        display: inline-block;
        padding: 15px 20px;
    }
 
    a:hover {
        background: #1d85e8;
        text-decoration: none;
    }
`
const Logo = styled.img`
    width: 25rem;
    height: 25rem;
`
const H3 = styled.div`
    width: 25rem;
    height: 25rem;
    padding: 5.5rem 2.5rem 2.5rem 2.5rem;
    @media (max-width: 420px) { 
        display: none;
        width: 0rem;
        height: 0rem;
      }
`
const Logo2 = styled.img`
    width: 70px;
    height: 70px;
    transform: scaleX(-1);
`
const HEADER = styled.header`
    font-size: 50px;
    font-weight: bold;
    color: #FFDD33;
    // text-decoration: underline #092c4c;
    width: 100%;
    display: flex;
    justify-content: center;
    margin: .5rem 2rem;
    padding: 0rem;
    background: #fff;
    // grid-column: span 2;

    @media (max-width: 420px) { 
        max-width: 420px;
        font-size: 20px;
        color: #FFDD33;
        margin: 2rem;
      }
`
const HEADER2 = styled.p`
    width: 0%;
    //width: 100%;
    margin: 2rem;
    //font-size: 30px;
    
    display: none;
    @media (max-width: 510px) { 
        width: 100%;
        max-width: 420px;
        font-size: 15px;
        margin: 2rem;
        font-weight: bold;
        text-aling: center;
        display: flex;
        justify-content: center;
      }
`
export default App;